import React, { useState } from "react";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import TabsComponent from "./tabs";
import FilterComponent from "./filter";
import TableComponent from "./commonTables";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CustomModal from "./customModal";
import {
  fetchPayment,
  fetchFop,
  fetchPos,
  deletePayment,
  deletePOS,
  fetchAffectedItems,
  fetchFopAffectedItems,
  deleteFOP,
  addNewMarket,
  putPayment,
  addNewFop,
  addNewPos,
  SetAffectedItems,
  fetchHistory,
} from "../../redux/slices/paymentSlice";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment/moment";
import FopFilterComponent from "./fopFilter";
import HistoryFilterComponent from "./historyFilter";
// import HistoryFilterComponent from "./historyFilter";
import posJson from "../../utils/pos.json";

const initialData = {
  sellerType: [],
  pos: "",
  fop: [],
  cash: [],
  comment: "",
};

const ResponsiveTabsTable = (props) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [filter, setFilter] = useState("");
  const [posFilter, setPosFilter] = useState("");
  const [fopFilter, setFopFilter] = useState("");
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [newMarketModal, setNewMarketModal] = useState(false);
  const [editMarketModal, setEditMarketModal] = useState(false);
  const [deleteMarketModal, setDeleteMarketModal] = useState(false);
  const [modalData, setModalData] = useState(initialData);

  const [check, setCheck] = useState(false);
  const [originalData, setOriginalData] = useState(initialData);

  const [isAddingFop, setIsAddingFop] = useState(false);
  const [newFopData, setNewFopData] = useState({
    paymentCode: "",
    fopName: "",
    date: moment().format("MMM DD, YYYY"),
  });

  const [isAddingPos, setIsAddingPos] = useState(false);
  const [newPosData, setNewPosData] = useState({
    pos: "",
    countryName: "",
    date: moment().format("MMM DD, YYYY"),
  });

  const isMobile = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();

  const {
    payments,
    fopDetails,
    posDetails,
    affectedItems,
    fopAffectedItems,
    historyDetails,
  } = useSelector((state) => state.paymentCatalogue);

  React.useEffect(() => {
    dispatch(fetchPayment());
    dispatch(fetchFop());
    dispatch(fetchPos());
    dispatch(fetchHistory());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    clearFilters();
    if (selectedTab === 0 || selectedTab) {
      dispatch(fetchHistory());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);

  // React.useEffect(() => {
  //   if (fopDetails?.data) {
  //     setModalData((prevData) => ({
  //       ...prevData,
  //       fopOptions: fopDetails.data.map((item) => ({
  //         label: item.paymentName,
  //         value: item.paymentCode,
  //       })),
  //     }));
  //   }
  // }, [fopDetails]);

  const dateChanges = (date) => {
    if (!date) return "";
    return moment(date).format("MMM DD, YYYY");
  };

  const clearFilters = () => {
    setFilter("");
    setPosFilter("");
    setFopFilter("");
    setSelectedFilters([]);
  };

  const handleAddFop = () => {
    setIsAddingFop(true);
    // setErrorMessage("");
    setNewFopData({
      payment: "",
      fopName: "",
      date: moment().format("MMM DD, YYYY"),
    });
  };

  const paymentOptions = [
    { label: "American Express", value: "AX" },
    { label: "Discover Card", value: "DS" },
    { label: "Diners Club", value: "DC" },
    { label: "China UnionPay", value: "UP" },
    { label: "Japan Credit Bureau", value: "JC" },
    { label: "MasterCard", value: "CA" },
    { label: "Universal Air Travel Plan (UATP)", value: "TP" },
    { label: "VISA International", value: "VI" },
    { label: "MIR", value: "MR" },
    { label: "Credito Directo payment", value: "AM" },
    { label: "Cards issued by Bank Card", value: "BC" },
    { label: "Cards issued by KB", value: "CN" },
    { label: "Cards issued by KEB", value: "EB" },
    { label: "Elo", value: "EL" },
  ].sort((a, b) => a.value.localeCompare(b.value)); // Sort alphabetically by value;

  const posOptions = posJson;

  const handleSaveFop = () => {
    // const selectedOption = paymentOptions.find((option) => {
    //   return option.value === newFopData.payment;
    // });

    // if (selectedOption) {
    dispatch(
      addNewFop({
        paymentCode: newFopData.payment.trim(),
        paymentName: newFopData.fopName.trim(),
        comments: "Added via UI",
      })
    );
    setIsAddingFop(false);
    setNewFopData({
      payment: "",
      fopName: "",
      date: moment().format("MMM DD, YYYY"),
    });
    return true;
    // }
  };

  const handleCancelFop = () => {
    setIsAddingFop(false);

    setNewFopData({
      payment: "",
      fopName: "",
      date: moment().format("MMM DD, YYYY"),
    });
  };

  const handleAddPos = () => {
    setIsAddingPos(true);
  };

  const handleSavePos = () => {
    const selectedOption = posOptions?.find(
      (option) => option.value === newPosData.pos
    );

    if (selectedOption) {
      dispatch(
        addNewPos({
          pos: newPosData.pos,
          countryName: selectedOption.label,
          comment: "Added via UI",
        })
      );
      setIsAddingPos(false);
      setNewPosData({
        pos: "",
        countryName: "",
        date: moment().format("MMM DD, YYYY"),
      });
      return true;
    }
  };

  // Utility function to map history data
  const mapHistoryData = (data, tableName, logFields) =>
    (data || []).map((item) => ({
      date: item.date,
      action:
        item.status === "new"
          ? "Created"
          : item.status === "modify"
          ? "Modified"
          : item.status === "delete"
          ? "Deleted"
          : item.status.charAt(0).toUpperCase() + item.status.slice(1),
      name: item.user?.charAt(0).toUpperCase() + item.user?.slice(1),
      table: tableName,
      log: logFields.map((field) => `${field}: ${item[field] || ""}`),
      comments: item.comment || item.comments || "",
    }));
  // Data and Headings for each tab
  const tabData = [
    {
      headings: {
        date: "Last Modified",
        sellertype: "Seller type",
        pos: "POS",
        fop: "Eligible FOP",
        cash: "Cash",
      },
      data: payments?.data
        ?.slice() // Create a shallow copy of the array to avoid mutating the original
        ?.sort((a, b) => new Date(b.date) - new Date(a.date)) // Sort by date in descending order
        ?.map((item) => {
          return {
            id: item.id,
            posCode: item.pos,
            countryName: item.countryName,
            comment: item.comment,
            date: moment(item.date).format("MMM DD, YYYY"),
            action:
              item.status === "new"
                ? "Created"
                : item.status === "modify"
                ? "Modified"
                : item.status.charAt(0).toUpperCase() + item.status.slice(1),
            sellertype:
              item.sellerType.charAt(0).toUpperCase() +
              item.sellerType.slice(1),
            pos: item.countryName,
            fop: item.eligibleFOP,
            cash: item.cash === "TRUE" ? "Enabled" : "Disabled",
            name: item.user.charAt(0).toUpperCase() + item.user.slice(1),
            eligibleFOPDetail: item.eligibleFOPDetail,
          };
        }),
    },
    {
      headings: {
        date: "Created by",
        payment: "Payment Code",
        fopName: "FOP name",
      },
      data: fopDetails?.data
        ?.slice()
        ?.sort((a, b) => new Date(b.date) - new Date(a.date))
        ?.map((item) => {
          return {
            id: item.id,
            date: dateChanges(item.date),
            payment: item.paymentCode,
            fopName: item.paymentName,
            name: item.user,
          };
        }),
    },
    {
      headings: {
        date: "Created by",
        countryCode: "Country Code",
        country: "Country",
      },
      data: posDetails?.data
        ?.slice()
        ?.sort((a, b) => new Date(b.date) - new Date(a.date))
        ?.map((item) => {
          return {
            id: item.id,
            date: dateChanges(item.date),
            countryCode: item.pos,
            country: item.countryName,
            name: item.user.charAt(0).toUpperCase() + item.user.slice(1),
          };
        }),
    },
    {
      headings: {
        date: "Date",
        name: "Name",
        table: "Table",
        log: "Log",
        comments: "Comments",
      },
      data: [
        ...mapHistoryData(
          historyDetails?.paymentCatalogue,
          "Payment Catalogue",
          ["sellerType", "pos", "cash", "paymentType"]
        ),
        ...mapHistoryData(historyDetails?.paymentCataloguePOS, "POS", [
          "pos",
          "countryName",
        ]),
        ...mapHistoryData(
          historyDetails?.paymentCatalogueType,
          "List of Payments",
          ["paymentCode", "paymentName"]
        ),
      ].sort((a, b) => new Date(b.date) - new Date(a.date)), // Sort by date in descending order
    },
  ];

  const handleNewMarketModalOpen = () => setNewMarketModal(true);
  const handleNewMarketModalClose = () => {
    setNewMarketModal(false);
    setModalData(initialData);
    setCheck(false);
  };

  const handleEditMarketModalOpen = (rowData) => {
    const updatedModalData = {
      id: rowData.id,
      sellerType: rowData.sellertype.toLowerCase(), // Map sellertype to sellerType
      pos: rowData.posCode || "", // Map pos
      countryName: rowData.countryName,
      fop: rowData.fop ? rowData.fop.split(",").map((f) => f.trim()) : [],
      cash: rowData.cash === "Enabled" ? "enabled" : "disabled", // Map cash
      comment: rowData.comment || "", // Map comment (if available)
    };
    setModalData(updatedModalData);
    setOriginalData(updatedModalData); // Store the original data for comparison
    setEditMarketModal(true);
  };

  const handleEditMarketModalClose = () => {
    setEditMarketModal(false);
    setModalData(initialData);
  };

  const handleDeleteMarketModalOpen = (id, type = "payment") => {
    // Find the selected payment by ID
    if (type === "payment") {
      const selectedPayment = payments?.data?.find((item) => item.id === id);
      if (selectedPayment) {
        setModalData({
          sellerType: selectedPayment.sellerType
            ? [selectedPayment.sellerType]
            : [],
          pos: selectedPayment.pos || selectedPayment.countryName || "N/A",
          countryName: selectedPayment.countryName || "N/A",
          comment: selectedPayment.comment || "",
          id: selectedPayment.id,
        });
      }
    } else if (type === "pos") {
      dispatch(fetchAffectedItems({ id }));
      const selectedPOS = posDetails?.data?.find((item) => item.id === id);
      if (selectedPOS) {
        setModalData({
          pos: selectedPOS.pos || "N/A",
          countryName: selectedPOS.countryName || "N/A",
          id: selectedPOS.id,
          posImpactedMarkets: affectedItems,
        });
      }
    } else if (type === "fop") {
      dispatch(fetchFopAffectedItems({ id }));
      const selectedFOP = fopDetails?.data?.find((item) => item.id === id);
      if (selectedFOP) {
        setModalData({
          fop: `${selectedFOP.paymentCode} - ${selectedFOP.paymentName}`,
          impactedMarkets: fopAffectedItems,
          id: selectedFOP.id,
        });
      }
    }
    setDeleteMarketModal(true); // Open the delete modal
  };
  const handleDeleteMarketModalClose = () => {
    setDeleteMarketModal(false);
    setModalData(initialData);
    dispatch(SetAffectedItems([]));
  };

  const handleCombinationCheck = (sellerType, pos) => {
    const sellerTypeMapping = {
      CR: "consumer",
      AG: "agency",
    };
    const mappedSellerType = sellerTypeMapping[sellerType];
    const exists = payments?.data?.some(
      (payment) =>
        payment.sellerType === mappedSellerType && payment.pos === pos
    );
    return exists;
  };

  const handleSubmit = (type) => {
    // Handle submit logic
    const combination = handleCombinationCheck(
      modalData.sellerType,
      modalData.pos
    );

    if (combination) {
      setCheck(true);

      return;
    } else if (type === "edit") {
      const hasEligibleFopChanged = modalData.fop !== originalData.fop;
      const hasCashChanged = modalData.cash !== originalData.cash;

      if (!hasEligibleFopChanged && !hasCashChanged) {
        setCheck(true); // Show notification if no changes are made
        return;
      }
      dispatch(putPayment(modalData));
      handleEditMarketModalClose();
    } else {
      dispatch(addNewMarket(modalData));
    }
    handleNewMarketModalClose();
  };

  const handleDeleteMarket = () => {
    if (modalData.fop) {
      dispatch(deleteFOP({ modalData }));
    } else if (modalData.sellerType) {
      dispatch(deletePayment({ modalData }));
    } else {
      dispatch(deletePOS({ modalData }));
    }
    handleDeleteMarketModalClose();
  };

  React.useEffect(() => {
    if (deleteMarketModal && modalData.id) {
      if (modalData.pos) {
        setModalData((prevData) => ({
          ...prevData,
          posImpactedMarkets: affectedItems,
        }));
      } else if (modalData.fop) {
        setModalData((prevData) => ({
          ...prevData,
          impactedMarkets: fopAffectedItems,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [affectedItems, fopAffectedItems, deleteMarketModal, modalData.id]);

  const fields = [
    {
      type: "dropdown",
      label: "Seller type",
      value: modalData.sellerType,
      isMultiple: true,
      options: [
        {
          label: "Consumer",
          value: "CR",
        },
        {
          label: "Agency",
          value: "AG",
        },
      ],
      onChange: (e) => {
        setModalData((prevData) => ({
          ...prevData,
          sellerType: e.target.value,
        }));
      },
    },
    {
      type: "dropdown",
      label: "POS",
      isMultiple: false,
      value: modalData.pos,
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, pos: e.target.value }));
      },

      options: posDetails?.data
        ?.map((item) => ({
          label: item.countryName,
          value: item.pos,
        }))
        ?.sort((a, b) => a.label.localeCompare(b.label)), // Sort alphabetically by countryName,
      //[
      // { label: posDetails.countryName, value: posDetails.pos },
      // { label: "Canada", value: "CA" },
      // { label: "Mexico", value: "MX" },
      // { label: "United Kingdom", value: "UK" },
      // { label: "Germany", value: "DE" },
      // { label: "France", value: "FR" },
      // { label: "Italy", value: "IT" },
      // { label: "Spain", value: "ES" },
      // { label: "Australia", value: "AU" },
      // { label: "Japan", value: "JP" },
      // { label: "China", value: "CN" },
      // { label: "India", value: "IN" },
      // { label: "Brazil", value: "BR" },
      // { label: "South Africa", value: "ZA" },
      // { label: "Russia", value: "RU" },
      // { label: "Inouth", value: "NS" },
      // ],
    },
    {
      type: "multidropdown",
      label: "Eligible FOP",
      isMultiple: false,
      value: modalData?.fop,
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, fop: e.target.value }));
      },
      options: fopDetails?.data
        ?.map((item) => ({
          label: item.paymentCode, // to display in UI
          value: item.paymentCode, //to send response to Api
        }))
        ?.sort((a, b) => a.label.localeCompare(b.label)), // Sort alphabetically by FOP name,
      // [
      //   { label: "VI", value: "VIIII" },
      //   { label: "MC", value: "MCccc" },
      //   { label: "AM", value: "AMEX" },
      //   { label: "DI", value: "DISC" },
      //   { label: "DC", value: "DCxc" },
      //   { label: "JC", value: "JCB" },
      //   { label: "UP", value: "UPI" },
      //   { label: "MA", value: "MAES" },
      //   { label: "EL", value: "ELO" },
      //   { label: "HI", value: "HIP" },
      //   {label: "EB", value: "EBkdj" },
      // ],
    },
    {
      type: "dropdown",
      isMultiple: false,
      label: "Cash",
      value: modalData.cash,
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, cash: e.target.value }));
      },
      options: [
        { label: "Enabled", value: "enabled" },
        { label: "Disabled", value: "disabled" },
      ],
    },
    {
      type: "comment",
      value: modalData.comment,
      placeholder: "Please provide business justification.",
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, comment: e.target.value }));
      },
    },
  ];

  const editFields = [
    {
      type: "display",
      value: () => (
        <>
          You are currently editing market: {modalData.sellerType}, POS{" "}
          {modalData.pos} - {modalData.countryName}.
        </>
      ),
    },
    {
      type: "multidropdown",
      label: "Eligible FOP",
      isMultiple: false,
      value: modalData.fop,
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, fop: e.target.value }));
      },
      options: fopDetails?.data?.map((item) => ({
        label: item.paymentCode,
        value: item.paymentCode,
      })),
    },
    {
      type: "dropdown",
      label: "Cash",
      value: modalData.cash,
      isMultiple: false,
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, cash: e.target.value }));
      },
      options: [
        { label: "Enabled", value: "enabled" },
        { label: "Disabled", value: "disabled" },
      ],
    },
    {
      type: "comment",
      value: modalData.comment,
      placeholder: "Please provide business justification.",
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, comment: e.target.value }));
      },
    },
  ];

  const deleteFields = [
    {
      type: "display",
      value: () => (
        <>
          {modalData.fop ? (
            <>
              Are you sure you want to delete this Form of Payment:{" "}
              {modalData.fop || "N/A"}? <br />
              <br />
              <span style={{ fontWeight: "normal" }}>
                See below the full list of impacted markets from this change:
                {modalData.impactedMarkets?.data?.length > 0 ? (
                  <ul>
                    {(modalData.impactedMarkets?.data || []).map(
                      (market, index) => (
                        <li key={index}>
                          {market.sellerType.charAt(0).toUpperCase() +
                            market.sellerType.slice(1)}{" "}
                          {market.pos} - {market.countryName}
                        </li>
                      )
                    )}
                  </ul>
                ) : (
                  <div>-</div>
                )}
              </span>
            </>
          ) : modalData.sellerType ? (
            <>
              Are you sure you want to delete Market:{" "}
              {modalData.sellerType
                ?.map((type) => type.charAt(0).toUpperCase() + type.slice(1))
                .join(", ") || "N/A"}
              -{modalData.pos || "N/A"}, {modalData.countryName || "N/A"}.
            </>
          ) : (
            <>
              Are you sure you want to delete this Point of Sale:{" "}
              {modalData.pos || "N/A"} - {modalData.countryName || "N/A"}?{" "}
              <br />
              <br />
              {modalData.posImpactedMarkets?.data?.length > 0 ? (
                <div style={{ fontWeight: "normal" }}>
                  Consumer flows & Agency flows will be disabled for{" "}
                  {modalData.posImpactedMarkets.data[0].pos || "N/A"} -{" "}
                  {modalData.posImpactedMarkets.data[0].countryName || "N/A"}.{" "}
                  <br />
                  No FOP will be supported anymore in that POS.
                </div>
              ) : (
                <div style={{ fontWeight: "normal" }}>
                  Consumer flows & Agency flows will be disabled for - <br />
                  No FOP will be supported anymore in that POS.
                </div>
              )}
            </>
          )}
          <div
            style={{
              color: "#851109",
              marginTop: ".75rem",
            }}
          >
            This action cannot be reverted.
          </div>
        </>
      ),
    },
    {
      type: "comment",
      value: modalData.comment,
      placeholder: "Please provide business justification.",
      onChange: (e) => {
        setModalData((prevData) => ({ ...prevData, comment: e.target.value }));
      },
    },
  ];

  const handleSelectedFilters = (row, selectedFilters) => {
    const filterGroups = {
      sellertype: [],
      cash: [],
      lastModified: [],
      status: [],
      table: [],
    };

    selectedFilters.forEach((filter) => {
      if (["Agency", "Consumer"].includes(filter)) {
        filterGroups.sellertype.push(filter.toLowerCase());
      } else if (["Enabled", "Disabled"].includes(filter)) {
        filterGroups.cash.push(filter.toLowerCase());
      } else if (["Created", "Modified", "Deleted"].includes(filter)) {
        filterGroups.status.push(filter.toLowerCase());
      } else if (
        ["Payment Catalogue", "Form of Payment", "Point of Sale"].includes(
          filter
        )
      ) {
        // Map filter values to the corresponding table names
        const tableNameMap = {
          "Payment Catalogue": "payment catalogue",
          "Form of Payment": "list of payments",
          "Point of Sale": "pos",
        };
        filterGroups.table.push(tableNameMap[filter].toLowerCase());
      }
    });

    const sellertypeMatch =
      filterGroups.sellertype.length === 0 ||
      filterGroups.sellertype.includes(row.sellertype?.toLowerCase());

    const cashMatch =
      filterGroups.cash.length === 0 ||
      filterGroups.cash.includes(row.cash?.toLowerCase());

    const lastModifiedMatch =
      filterGroups.lastModified.length === 0 ||
      filterGroups.lastModified.includes(row.action?.toLowerCase());

    const statusMatch =
      filterGroups.status.length === 0 ||
      filterGroups.status.includes(row.action?.toLowerCase());

    const tableMatch =
      filterGroups.table.length === 0 ||
      filterGroups.table.includes(row.table?.toLowerCase());

    return (
      sellertypeMatch &&
      cashMatch &&
      lastModifiedMatch &&
      statusMatch &&
      tableMatch
    );
  };

  // Filtered data for the selected tab
  const filteredData =
    tabData[selectedTab]?.data?.filter((row) => {
      const { date, ...rest } = row;

      // Apply date range filter only for the history tab
      const isWithinDateRange =
        selectedTab === 3
          ? (!fromDate || new Date(date) >= new Date(fromDate)) &&
            (!toDate || new Date(date) <= new Date(toDate))
          : true;

      const values = Object.values(rest).join(" ").toLowerCase();
      const filtermatch = values.includes(filter?.toLowerCase());
      const selectedFilterMatch =
        selectedFilters.length === 0 ||
        handleSelectedFilters(row, selectedFilters);

      // const handleSearch = values.includes(filter.toLowerCase());

      const fopArray = row.fop?.toLowerCase().split(",") || [];
      const fopFilterArray = fopFilter
        ? [...new Set(fopFilter?.toLowerCase().split(/[, ]+/))]
        : [];

      const fopFilterMatch =
        fopFilterArray.length === 0 ||
        fopFilterArray.every((fop) =>
          fopArray.some((item) => item.includes(fop))
        );

      const filterHandle =
        (posFilter === "" ||
          row.pos
            ?.toLowerCase()
            .includes(posFilter.toString()?.toLowerCase())) &&
        fopFilterMatch &&
        filtermatch &&
        selectedFilterMatch;

      const filterDropDownHandle =
        (posFilter === "" ||
          row.pos
            ?.toLowerCase()
            .includes(posFilter.toString()?.toLowerCase())) &&
        fopFilterMatch &&
        filtermatch &&
        selectedFilterMatch;

      const filterCondition =
        posFilter || fopFilter ? filterHandle : filterDropDownHandle;

      return filterCondition && isWithinDateRange;
    }) || [];

  return (
    <Box sx={{ padding: 5, pt: 3 }}>
      <Box sx={{ mb: "36px", mt: "12px" }}>
        <Typography
          sx={{
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: isMobile ? "24px" : "36px",
            lineHeight: isMobile ? "32px" : "48px",
            color: "#000000",
          }}
        >
          Payment Catalogue
        </Typography>
      </Box>
      {/* Tabs */}
      <Box
        sx={{
          boxShadow: isMobile ? "0 -5px 10px rgba(0,0,0,0.1) " : "none",
          borderTopLeftRadius: isMobile ? "8px" : 0,
          borderTopRightRadius: isMobile ? "8px" : 0,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <TabsComponent
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
        <Button
          variant="text"
          disabled
          sx={{
            textTransform: "none",
            fontFamily: "Open Sans",
            fontWeight: 700,
            fontSize: "16px",
            lineHeight: "20px",
            mr: "20px",
          }}
        >
          <SaveAltIcon sx={{ mr: "10px", width: "20px", height: "20px" }} />
          Download Report
        </Button>
      </Box>

      {/* Filter */}
      <Box
        sx={{
          boxShadow: 10,
          padding: 3,
          backgroundColor: "#FFFFFF",
          borderBottomLeftRadius: "16px",
          borderBottomRightRadius: "16px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            justifyContent: "space-between",
            mb: "15px",
          }}
        >
          {selectedTab === 0 ? (
            <FilterComponent
              filter={filter}
              posFilter={posFilter}
              setPosFilter={setPosFilter}
              fopFilter={fopFilter}
              setFopFilter={setFopFilter}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              clearFilters={clearFilters}
              selectedTab={selectedTab}
            />
          ) : selectedTab === 1 || selectedTab === 2 ? (
            <FopFilterComponent filter={filter} setFilter={setFilter} />
          ) : (
            <HistoryFilterComponent
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              setToDate={setToDate}
              filter={filter}
              setFilter={setFilter}
            />
          )}
          {selectedTab !== 3 ? (
            <Button
              variant="contained"
              // disabled
              onClick={
                selectedTab === 0
                  ? handleNewMarketModalOpen
                  : selectedTab === 1
                  ? handleAddFop
                  : handleAddPos
              }
              sx={{
                textTransform: "none",
                display: "flex",
                justifyContent: isMobile ? "center" : "none",
                fontFamily: "Open Sans",
                fontWeight: 700,
                fontSize: "16px",
                lineHeight: "20px",
                height: "41px",
                minWidth: "120px",
                pl: "25px",
                pr: "25px",
                borderRadius: "24px",
                mb: "20px",
              }}
            >
              {selectedTab === 0
                ? "Add New Market"
                : selectedTab === 1
                ? "Add Form of Payment"
                : selectedTab === 2
                ? "Add Point of Sale"
                : ""}
            </Button>
          ) : (
            ""
          )}
        </Box>

        {/* Table */}
        <TableComponent
          headings={tabData[selectedTab].headings}
          tableData={filteredData}
          selectedTab={selectedTab}
          handleEdit={handleEditMarketModalOpen}
          handleDelete={(id) =>
            handleDeleteMarketModalOpen(
              id,
              selectedTab === 2 ? "pos" : selectedTab === 1 ? "fop" : "payment"
            )
          }
          isAddingFop={isAddingFop}
          setIsAddingFop={setIsAddingFop}
          setNewFopData={setNewFopData}
          newFopData={newFopData}
          handleAddFop={handleAddFop}
          paymentOptions={paymentOptions}
          fopAddingName={props.fopAddingName}
          fopDetails={fopDetails}
          handleSaveFop={handleSaveFop}
          handleCancelFop={handleCancelFop}
          isAddingPos={isAddingPos}
          setIsAddingPos={setIsAddingPos}
          newPosData={newPosData}
          handleAddPos={handleAddPos}
          handleSavePos={handleSavePos}
          setNewPosData={setNewPosData}
          posDetails={posDetails}
          posOptions={posOptions}
          check={check}
        />
      </Box>
      {newMarketModal && (
        <CustomModal
          open={newMarketModal}
          handleClose={handleNewMarketModalClose}
          title="Add new market"
          fields={fields}
          showInputs={true}
          type="add"
          submitButtonText={"Add now"}
          submitButtonDisabled={true}
          handleSubmit={handleSubmit}
          showSubmit={true}
          showCancel={false}
          showNotif={true}
          check={check}
          notifText={
            "This market already exists. Please modify the existing market."
          }
        />
      )}

      {editMarketModal && (
        <CustomModal
          open={editMarketModal}
          handleClose={handleEditMarketModalClose}
          title="Edit market"
          fields={editFields}
          showInputs={true}
          type="edit"
          handleSubmit={handleSubmit}
          submitButtonText={"Edit now"}
          showSubmit={true}
          submitButtonDisabled={true}
          check={check}
          showCancel={false}
          showNotif={true}
          notifText={"Please edit at least one field to continue."}
        />
      )}
      {deleteMarketModal && (
        <CustomModal
          open={deleteMarketModal}
          handleClose={handleDeleteMarketModalClose}
          title={
            modalData.fop
              ? "Delete Form of Payment"
              : modalData.sellerType
              ? "Delete Market"
              : "Delete Point of Sale"
          }
          fields={deleteFields}
          type="delete"
          showInputs={true}
          infoText=""
          handleDeleteMarket={() => handleDeleteMarket(modalData.id)}
          showSubmit={true}
          showCancel={true}
          submitButtonText={"Yes"}
          cancelButtonText={"No"}
          showNotif={false}
        />
      )}
    </Box>
  );
};

export default ResponsiveTabsTable;
